/** @format */

import WebMercatorViewport, { getBounds } from '@math.gl/web-mercator';

interface Viewport {
  latitude: number;
  longitude: number;
  zoom: number;
}

function getMapCorners(viewport: Viewport, width: number, height: number) {
  const webMercatorViewport = new WebMercatorViewport({
    width: width,
    height: height,
    latitude: viewport.latitude,
    longitude: viewport.longitude,
    zoom: viewport.zoom,
  });

  const [sw, se, ne, nw] = getBounds(webMercatorViewport).map(([lon, lat]) => [lon, lat]);
  return { sw, se, ne, nw };
}

export { getMapCorners };
